import React, { useState } from "react";
import TablePagination from "@mui/material/TablePagination";
import { Button, TextField } from "@mui/material";
import styles from "../pagination.module.css";

const CustomPagination: React.FC<any> = (props) => {
  const { count, page, rowsPerPage, onPageChange } = props;
  const [gotoPage, setGotoPage] = useState(`${page + 1}`);
  const handleGotoPage = () => {
    const pageNumber = parseInt(gotoPage, 10);
    if (pageNumber >= 1 && pageNumber <= Math.ceil(count / rowsPerPage)) {
      onPageChange(null, pageNumber - 1);
    }
  };
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
      <TablePagination
        component="div"
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[]}
        {...props}
      />
      <div style={{ padding: 5 }}>
        <TextField
          label="Jump To Page"
          value={gotoPage}
          className={styles.jumpInput}
          onChange={(e) => setGotoPage(e.target.value)}
          margin="none"
          size="small"
          type="number"
          slotProps={{ htmlInput: {
            min: 1,
            max: Math.ceil(count / rowsPerPage),
          } }}
          style={{ fontWeight: 300 }}
        />
        <Button color="primary" variant="contained" onClick={handleGotoPage}>Go</Button>
      </div>
    </div>
  );
};
export default CustomPagination;

